export default {
	"add0f240cbd4914fd1aed8305872a3f4": "商品價格",
	"842adf4dcc244345b0c757e41a063bd5": "簽約優惠",
	"0c7bd83e46479eb03047f35d4a76284b": "簽約價",
	"7494bddf5fbef99f30017752738b0f71": "您已進行內容體驗，支付解鎖全量內容"
}
